import React from 'react';
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from 'react-icons/md';

import Button from './Button';

export function Pagination({ previousPage, nextPage }) {
  if (!previousPage && !nextPage) return null;

  return (
    <div className="w-full my-2 inline-flex">
      {previousPage && (
        <Button style={{ paddingLeft: 18 }} primary href={previousPage}>
          <MdKeyboardArrowLeft style={{ verticalAlign: 'middle' }} /> Newer
        </Button>
      )}

      {nextPage && (
        <Button
          style={{ marginLeft: 'auto', paddingRight: 18 }}
          primary
          href={nextPage}
        >
          Older <MdKeyboardArrowRight style={{ verticalAlign: 'middle' }} />
        </Button>
      )}
    </div>
  );
}
